import LocalStorageWorker from './localStorage.worker?worker';

export default LocalStorageWorker;
